import { Button, Stack, Typography } from '@mui/material';
import { calculateEconomics, rubles } from 'src/utils/intentEconomics';

import type { Workspace } from 'src/services/IntentService';

export default function ProjectContext({
    workspace,
    available,
    loading,
    launch,
}: {
    workspace: Workspace | null;
    available: boolean;
    loading: boolean;
    launch: () => void;
}) {
    const economics = workspace ? calculateEconomics(workspace.economics) : null;
    return (
        <Stack
            spacing={0}
            className="project-context-content"
        >
            <Typography
                component="h2"
                fontWeight={700}
            >
                Контекст потока
            </Typography>
            {loading ? (
                <Typography color="text.secondary">Загружаем данные…</Typography>
            ) : !available ? (
                <div className="project-context-section">
                    <Typography color="text.secondary">Данные потока недоступны.</Typography>
                    <Typography variant="body2">
                        Здесь будут экономика запуска, остатки лидов и срок действия подключённых услуг.
                    </Typography>
                </div>
            ) : !workspace ? (
                <Typography
                    color="text.secondary"
                    className="project-context-section"
                >
                    Создайте поток и опишите бизнес.
                </Typography>
            ) : (
                <>
                    <div className="project-context-section">
                        <Typography fontWeight={600}>{workspace.name}</Typography>
                        <Typography
                            variant="body2"
                            color="text.secondary"
                        >
                            {workspace.profile.region || 'Регион не указан'}
                        </Typography>
                        <ol
                            className="project-context-steps"
                            aria-label="Готовность потока"
                        >
                            <li data-complete={Boolean(workspace.profile.description)}>
                                <span>{workspace.profile.description ? '✓' : '1'}</span>Профиль бизнеса
                            </li>
                            <li data-complete={Boolean(economics)}>
                                <span>{economics ? '✓' : '2'}</span>Экономика лида
                            </li>
                            <li data-complete={Boolean(workspace.streams.length)}>
                                <span>{workspace.streams.length ? '✓' : '3'}</span>Поток лидов
                            </li>
                        </ol>
                    </div>
                    <div className="project-context-section">
                        <Typography
                            variant="body2"
                            color="text.secondary"
                        >
                            Ценность одного лида до привлечения
                        </Typography>
                        <Typography fontWeight={600}>
                            {economics ? rubles(economics.value) : 'Нужны данные о продажах'}
                        </Typography>
                        <Typography
                            variant="caption"
                            color="text.secondary"
                        >
                            Прогноз по вашим вводным, не гарантия.
                        </Typography>
                    </div>
                    {workspace.streams.map((stream) => (
                        <div
                            key={stream.id}
                            className="project-context-section"
                        >
                            <Typography fontWeight={600}>{stream.name || stream.category_name}</Typography>
                            <Typography variant="body2">
                                {stream.is_active ? 'Поиск работает' : 'Поиск остановлен'} · {stream.balance} лидов
                                осталось
                            </Typography>
                            {stream.access_expires_at && (
                                <Typography variant="body2">
                                    {stream.access_name || 'Доступ'} до{' '}
                                    {new Date(stream.access_expires_at).toLocaleDateString('ru-RU')}
                                </Typography>
                            )}
                        </div>
                    ))}
                    <Button
                        className="project-context-action"
                        variant="outlined"
                        onClick={launch}
                    >
                        {workspace.streams.length ? 'Пополнить пакет' : 'Рассчитать запуск'}
                    </Button>
                </>
            )}
        </Stack>
    );
}
